import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { deleteAccountEmployeeTimeEntryTimerAsync, resetTimerState, stopAccountEmployeeTimeEntryTimerAsync, updateIsReload, updateTimerFromNavbarState, updateTimerTimesheet } from "./timesheetSlice";
import { getTimeFromDecimal, timeConverIntoSeconds } from "../../common/timesheetFunction";
import { ShowToast } from "../../common/Toastr";
import { getValueFromResource } from "../../common/timeLiveFunction";

const TimerInforWedget = (prop: any) => {
    const { t } = prop
    const dispatch = useAppDispatch();
    const { timerObject, lastEntryTimerId, timeEntriesList, hoursRedux, minutesRedux, secondsRedux, autoTimer, isTimerCloseWithNoEntry,isTimerPulsing } = useAppSelector((state) => state.timesheet);
    
    const [time, setTime] = useState({ hours: hoursRedux, minutes: minutesRedux, seconds: secondsRedux });
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const [intervalId, setIntervalId] = useState<any | null>();
    const state = useAppSelector((state) => state.timesheet);
    const { timerWidgetData } = state;
    let timerPopUpData = timerWidgetData?.[0];
    let timerDate = moment(timerPopUpData?.TimerDate).format("DD MMM, YYYY")

    useEffect(() => {
        isTimerCloseWithNoEntry === false ? setTime({ hours: hoursRedux, minutes: minutesRedux, seconds: secondsRedux }) :
            setTime({ hours: 0, minutes: 0, seconds: 0 });
    }, [hoursRedux, minutesRedux, secondsRedux, isTimerCloseWithNoEntry]);
   
   
    // useEffect(() => {
    //     if (autoTimer) {
    //         const id = setInterval(() => {
    //             setTime((prevTime) => {
    //                 const newSeconds = prevTime.seconds + 1;
    //                 const newMinutes = prevTime.minutes + Math.floor(newSeconds / 60);
    //                 const newHours = prevTime.hours + Math.floor(newMinutes / 60);
    //                 dispatch(updateTimerTimesheet({
    //                     timerArray: [{
    //                         hours: newHours,
    //                         minutes: newMinutes % 60,
    //                         seconds: newSeconds % 60
    //                     }]
    //                 }));
    //                 // debouncedUpdateTimer({ hours: newHours, minutes: newMinutes % 60, seconds: newSeconds % 60 });
    //                 return {
    //                     hours: newHours,
    //                     minutes: newMinutes % 60,
    //                     seconds: newSeconds % 60,
    //                 };
    //             });
    //         }, 1000);
    //         setIntervalId(id);
    //     } else {
    //         clearInterval(intervalId);
    //     }
    //     return () => clearInterval(intervalId);
    // }, [autoTimer]);
// Timer Interval Logic
    useEffect(() => {
        if (autoTimer) {
            if (timerRef.current) clearInterval(timerRef.current);

            timerRef.current = setInterval(() => {
                setTime((prevTime) => {
                    const newSeconds = prevTime.seconds + 1;
                    const newMinutes = prevTime.minutes + Math.floor(newSeconds / 60);
                    const newHours = prevTime.hours + Math.floor(newMinutes / 60);

                    const updatedTime = {
                        hours: newHours,
                        minutes: newMinutes % 60,
                        seconds: newSeconds % 60,
                    };

                    dispatch(updateTimerTimesheet({
                        timerArray: [updatedTime]
                    }));

                    return updatedTime;
                });
            }, 1000);
        } else {
            
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
            
            setTime({ hours: 0, minutes: 0, seconds: 0 });
        }

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [autoTimer, dispatch]);

    const formatTimeUnit = (unit: any) => {
        return unit < 10 ? `0${unit}` : unit;
    }

    const stopTimer = () => {
        if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
    }

        let tempHours = '';
        timeEntriesList.map((item: any) => {
            if (item.IsTimer) {
                tempHours = getTimeFromDecimal(item.timeEntries.filter((x: any) => x.TimeEntryDate == moment(new Date()).format("YYYY-MM-DD"))[0].Hours, false);;
            }
        });
        dispatch(updateTimerFromNavbarState());
        // if (timerObject[0].minutes >= 1) {
        if ((timerObject[0].hours >= 1 && timerObject[0].minutes >= 0) || (timerObject[0].hours ==0  && timerObject[0].minutes >= 1)) {
            dispatch(stopAccountEmployeeTimeEntryTimerAsync(timeConverIntoSeconds(tempHours)))
                .unwrap()
                .then((result) => {
                    if (Number(result.id) > 0) {
                        dispatch(resetTimerState());
                        dispatch(updateIsReload(true));
                        ShowToast('Success', 'TimeEntry Updated Successfully!!', "success", "toast-top-right");
                    }
                    else {
                        ShowToast('error', 'TimeEntry is not Updated Successfully!', "error", "toast-top-right");
                    }
                })
                .catch((rejectedValueOrSerializedError) => {
                })
                .finally(() => {
                });
        } else {
            dispatch(deleteAccountEmployeeTimeEntryTimerAsync()).then((result) => {
                dispatch(resetTimerState());
                ShowToast('Warning', 'To Save the entry, Total time must be 1 minute or above', "warning", "toast-top-right");
            });
        }
    }
    return (
        <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-250px'
            data-kt-menu='true'>
            <span className=" project mx-3 mb-3">Timer Details</span>
            <div className="separator"></div>
            <div className="mx-5">
                <div className="row my-3 gap-5">
                    <div className="col-sm-2">
                        <span className="fs-7 fw-bold">{getValueFromResource('Date', dispatch, t)}</span>
                    </div>
                    <div className="col-sm-8">
                        <span className="fs-7 fw-normal" >{timerDate}</span>
                    </div>
                </div>
                <div className="row my-3 gap-5">
                    <div className="col-sm-2">
                        <span className="fs-7 fw-bold">{getValueFromResource('Client', dispatch, t)}</span>
                    </div>
                    <div className="col-sm-8">
                        <span className="fs-7 fw-normal" >{timerPopUpData?.ClientName}</span>
                    </div>
                </div>
                <div className="row my-3 gap-5">
                    <div className="col-sm-2">
                        <span className="fs-7 fw-bold">{getValueFromResource('Project', dispatch, t)}</span>
                    </div>
                    <div className="col-sm-8">
                        <span className="fs-7 fw-normal">{timerPopUpData?.ProjectName}</span>
                    </div>
                </div>
                <div className="row mt-3 gap-5">
                    <div className="col-sm-2">
                        <span className="fs-7 fw-bold">{getValueFromResource('Task', dispatch, t)}</span>
                    </div>
                    <div className="col-sm-8">
                        <span className="fs-7 fw-normal">{timerPopUpData?.TaskName}</span>
                    </div>
                </div>
            </div>

            <div className="mt-2">
                <div className="d-flex justify-content-center">
                    <span className='fs-2 text-gray-700 fw-bold me-2' style={{ cursor: "pointer" }}>{`${formatTimeUnit(time.hours)}:${formatTimeUnit(time.minutes)}:${formatTimeUnit(time.seconds)}`}</span>
                </div>
                <div className="my-4 d-flex justify-content-center">
                    <span className="symbol-label bg-light-danger cursor rounded-circle" style={{ padding: "10%" }} onClick={() => { stopTimer() }}>
                        <i className="bi bi-stop-circle text-danger" style={{ fontSize: "-webkit-xxx-large" }}></i>
                    </span>
                </div>
            </div>
        </div>

    )
}

export default TimerInforWedget;